export const DEFAULT_PAGE_SIZES = [5, 10, 15, 20, 25, 50];
export var TableVariant;
(function (TableVariant) {
    TableVariant["Grid"] = "grid";
    TableVariant["List"] = "list";
})(TableVariant || (TableVariant = {}));
//# sourceMappingURL=types.js.map